export class CEP {
  logradouro!: string;
  complemento!: string;
  bairro!: string;
  localidade!: string;
  uf!: string;
  ibge!: string;
  gia!: string;
  ddd!: string;
  siafi!: string;
  cep!: string;
}
